var map = {
	"./Ginetex-Symbols.svg": 62574,
	"./Gotham-Bold.svg": 28309,
	"./Gotham-BoldItalic.svg": 71020,
	"./Gotham-Italic.svg": 95311,
	"./Gotham.svg": 68177,
	"./wash_care_symbols.svg": 34745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15547;